import React, { useState, useEffect } from 'react';
import { CONSULTANT_INFO } from '../constants';
import Header from '../components/Header/Header';
import HeroSection from '../components/Sections/HeroSection';
import OzelliklerSection from '../components/Sections/OzelliklerSection';
import CustomerReviewSection from '../components/Sections/CustomerReviewSection';

// ... (existing imports)

import AksesuarlarSection from '../components/Sections/AksesuarlarSection';
import BebekOdakliSection from '../components/Sections/BebekOdakliSection';
import BilgiFormuSection from '../components/Sections/BilgiFormuSection';
import Footer from '../components/Footer/Footer';
import WhatsAppWidget from '../components/WhatsAppWidget/WhatsAppWidget';
import BilgiPopup from '../components/Popups/BilgiPopup';
import SecimPopup from '../components/Popups/SecimPopup';
import IcerikPopup from '../components/Popups/IcerikPopup';
import { useCopyToClipboard } from '../hooks/useCopyToClipboard';
import { useToast } from '../hooks/useToast';
import './HomePage.css';

const HomePage: React.FC = () => {
  const [bilgiPopupOpen, setBilgiPopupOpen] = useState(false);
  const [secimPopupOpen, setSecimPopupOpen] = useState(false);
  const [icerikPopupOpen, setIcerikPopupOpen] = useState(false);
  const [icerikPopupData, setIcerikPopupData] = useState<{ title?: string; content?: string }>({});
  const { copyToClipboard } = useCopyToClipboard();
  const { showToast, toastMessage, show } = useToast();

  const handleCopyToClipboard = () => {
    copyToClipboard(CONSULTANT_INFO.ID, () => {
      show('Panoya kopyalandı');
    });
  };

  useEffect(() => {
    const handleSmoothScroll = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const link = target.closest('a[href^="#"]') as HTMLAnchorElement;
      if (link) {
        e.preventDefault();
        const targetId = link.getAttribute('href')?.substring(1);
        if (targetId) {
          const element = document.getElementById(targetId);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      }
    };

    document.addEventListener('click', handleSmoothScroll);
    return () => document.removeEventListener('click', handleSmoothScroll);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setBilgiPopupOpen(true);
    }, 30000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setSecimPopupOpen(true);
  }, []);

  const handleOzellikClick = (ozellikId: string, ozellikName: string) => {
    const ozellikDetaylari: { [key: string]: { title: string; content: string } } = {
      'islevsellik': {
        title: 'Thermomix TM7 İşlevsel Özellikleri Nedir?',
        content: 'Thermomix TM7, 28 farklı fonksiyonu tek bir cihazda birleştirir. Doğrama, karıştırma, buharda pişirme, yoğurma, soteleme, öğütme, çırpma, sous-vide, yavaş pişirme ve daha birçok işlevi içerir. Bu özellikler sayesinde mutfakta ihtiyacınız olan birçok cihazın yerini tek başına alır.'
      },
      'rehberli-pisirme': {
        title: 'Thermomix TM7 Rehberli Pişirme Özelliği Nedir?',
        content: 'Thermomix TM7, dokunmatik ekranı aracılığıyla adım adım rehberlik sunar. Yemek tariflerini takip ederek profesyonel sonuçlar elde edebilirsiniz. Ekranda görünen talimatları takip ederek her zaman mükemmel sonuçlar alırsınız.'
      },
      'akilli-baglanti': {
        title: 'Thermomix TM7 Akıllı Bağlantı Özelliği Nedir?',
        content: 'Wi-Fi bağlantısı ile tarifleri senkronize edebilir, güncellemeleri alabilir ve cihazınızı uzaktan kontrol edebilirsiniz. Cookidoo platformu üzerinden binlerce tarife erişebilirsiniz.'
      },
      'hassaslik': {
        title: 'Thermomix TM7 Tartı Özelliği Nedir?',
        content: 'Hassas tartı sistemi ile malzemelerinizi gram hassasiyetinde ölçebilirsiniz. Bu sayede tariflerinizi mükemmel şekilde uygulayabilirsiniz. 0.1 gram hassasiyetinde ölçüm yapabilir.'
      },
      'yuksek-kapasite': {
        title: 'Thermomix TM7 Yüksek Kapasiteli Thermomix Dünyası',
        content: '2.2 litre kapasiteli karıştırma kabı ile büyük aileler için yeterli miktarda yemek hazırlayabilirsiniz. Aynı anda birden fazla yemek pişirebilirsiniz.'
      },
      'kendini-temizleme': {
        title: 'Thermomix TM7 Kendini Temizleme Özelliği Nedir, Nasıl Kullanılır?',
        content: 'Özel temizleme programı ile cihazınızı kolayca temizleyebilirsiniz. Sadece su ve deterjan ekleyerek otomatik temizlik yapabilirsiniz. Temizlik süreci sadece birkaç dakika sürer.'
      },
      'yenilikci-tasarim': {
        title: 'Thermomix TM7 Yenilikçi Tasarım Özelliği',
        content: 'Modern ve şık tasarımı ile mutfağınıza estetik bir değer katar. Kompakt yapısı ile az yer kaplar. Premium malzemelerden üretilmiştir.'
      },
      'guvenlik': {
        title: 'Thermomix TM7 Gelişmiş Güvenlik Özelliği',
        content: 'Çocuk kilidi, aşırı ısınma koruması ve diğer güvenlik özellikleri ile güvenli kullanım sağlar. Tüm güvenlik standartlarına uygundur.'
      }
    };

    const detay = ozellikDetaylari[ozellikId];
    if (detay) {
      setIcerikPopupData(detay);
      setIcerikPopupOpen(true);
    }
  };

  return (
    <div className="home-page">
      <Header onCopyToClipboard={handleCopyToClipboard} />
      <HeroSection onCopyToClipboard={handleCopyToClipboard} />
      <OzelliklerSection onOzellikClick={handleOzellikClick} />
      <AksesuarlarSection />
      <BebekOdakliSection />
      <CustomerReviewSection />
      <BilgiFormuSection />
      <Footer />
      <WhatsAppWidget />
      <BilgiPopup isOpen={bilgiPopupOpen} onClose={() => setBilgiPopupOpen(false)} />
      <SecimPopup
        isOpen={secimPopupOpen}
        onClose={() => setSecimPopupOpen(false)}
        onCopyToClipboard={handleCopyToClipboard}
      />
      <IcerikPopup
        isOpen={icerikPopupOpen}
        onClose={() => setIcerikPopupOpen(false)}
        title={icerikPopupData.title}
        content={icerikPopupData.content}
      />
      {showToast && (
        <div className="toast-notification">
          {toastMessage}
        </div>
      )}
    </div>
  );
};

export default HomePage;

